<template>
	<all-agency-projects-list :key="onlyProjects" :only-projects="onlyProjects"/>
</template>

<script>
	import AllAgencyProjectsList from "./AllAgencyProjectsList";

	export default {
		name: "AllAgencyProjectsView",
		components: {AllAgencyProjectsList},
		props: {
			onlyProjects: {
				type: Boolean
			}
		}
	};
</script>

<style scoped>

</style>
